import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
// import Loadable from 'react-loadable'

// import Async from 'react-code-splitting'
// const Home = (props) => <Async load={import('./home/Home')} componentProps={props} />
// const Category = (props) => <Async load={import('./Category')} componentProps={props} />
// const Product = (props) => <Async load={import('./product/Product')} componentProps={props} />
// const NotFound = (props) => <Async load={import('./NotFound')} componentProps={props} />

// import Home from './home/Home'
// import Category from './Category'
// import Product from './product/Product'
// import NotFound from './NotFound'

import routes from "../shared/routes";

// const LoadableComponent = Loadable({
// 	loader: () => import('./my-component'),
// 	loading: Loading,
// 	serverSideRequirePath: path.resolve(__dirname, './Example')
// })

class Body extends Component {
	render() {
		return <Switch>{routes.map((route, i) => <Route key={i} {...route} />)}</Switch>;
	}
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body.js